import { Box, Typography } from "@mui/material";
import React from "react";
import { ModalWrapper } from "components/modalWrapper";
import WellhubLogo from "assets/images/logos/logo-wellhub.png";
import ConexaLogo from "assets/images/logos/logo-conexa.png";
import OptumLogo from "assets/images/logos/logo-optum.png";
import SatLogo from "assets/images/logos/logo-sat.png";

interface CajuMaisModalProps {
  open: boolean;
  onClose: () => void;
}

export const CajuMaisModal = (props: CajuMaisModalProps) => {
  const cajuMaisProductsList = [
    {
      product: "Wellhub",
      logo: WellhubLogo,
    },
    {
      product: "Conexa",
      logo: ConexaLogo,
    },
    {
      product: "Optum",
      logo: OptumLogo,
    },
    {
      product: "SAT",
      logo: SatLogo,
    },
  ]

  return (
    <ModalWrapper
      title="Saúde e bem estar na Caju"
      subtitle="Cuide de seus colaboradores com parceiros integrados à plataforma da Caju"
      open={props.open}
      handleClose={props.onClose}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            md: "row",
          },
          alignItems: "center",
          gap: 3,
          justifyContent: "space-around",
          flexWrap: { xs: "wrap", sm: "nowrap" },
        }}
      >
        {cajuMaisProductsList.map((item) => (
          <Box key={item.product} sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            px: 2,
          }}>
            <img
              src={item.logo}
              alt={`Logotipo da ${item.product}`}
            />
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 500 }}>
              {item.product}
            </Typography>
          </Box>
        ))}
      </Box>
    </ModalWrapper>
  );
};
